import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchNutMaterials, createNutMaterial, deleteNutMaterial, updateNutMaterial } from '../../common/jsonstore';
import { NutMaterial } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError } from '../../services/messageApiService';

export interface IAuthentication {
  NutMaterial: NutMaterial[];
  success: any;
  isProcessingComplete: boolean;
}

const initialState: IAuthentication = { NutMaterial: [], success: {}, isProcessingComplete: false };

const NutMaterialSlice = createSlice({
  name: 'NutMaterials',
  initialState,
  reducers: {
    receiveNutMaterial: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        NutMaterial: action.payload,
        isProcessingComplete: false
      };
    },
    success: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        success: action.payload,
        isProcessingComplete: true
      };
    }
  }
});


export const loadNutMaterials = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const NutMaterials = await fetchNutMaterials().then((res: any) => {
      dispatch(NutMaterialSlice.actions.receiveNutMaterial(res))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut material not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addNutMaterial = (newNutMaterial: NutMaterial): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await createNutMaterial(newNutMaterial).then((resp: any) => {
      dispatch(NutMaterialSlice.actions.receiveNutMaterial([...getState().NutMaterials.NutMaterial, resp.data[0]]));
      dispatch(NutMaterialSlice.actions.success({ 'sts': true, data: resp?.msg }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut Material Not Added';
        dispatch(NutMaterialSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyNutMaterial = (newNutMaterial: NutMaterial, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await updateNutMaterial(newNutMaterial, id).then((res: any) => {
      const updatedFittingSizes = getState().NutMaterials.NutMaterial.map(el => (el.id === id ? res : el))
      dispatch(NutMaterialSlice.actions.receiveNutMaterial(updatedFittingSizes));
      dispatch(NutMaterialSlice.actions.success({ 'sts': true, data: 'Nut Material Updated successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut Material Not Updated';
        dispatch(NutMaterialSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeNutMaterial = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteNutMaterial(id).then((res: any) => {
      const updatedNutMaterials = getState().NutMaterials.NutMaterial.filter((item) => item.id !== id);
      dispatch(NutMaterialSlice.actions.receiveNutMaterial(updatedNutMaterials));
      dispatch(NutMaterialSlice.actions.success({ 'sts': true, data: 'Nut Material deleted successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut Material deleted successfully';
        dispatch(NutMaterialSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  dispatch(NutMaterialSlice.actions.success(data));
}

export default NutMaterialSlice.reducer;
